import { useEffect, useState } from "react";
import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import NoticeBar from "@/pages/home/components/NoticeBar";
import ReplaySection from "@/pages/home/components/ReplaySection";
import WelfareSection from "@/pages/home/components/WelfareSection";
import RankingSection from "@/pages/home/components/RankingSection";
import CategorySection from "@/pages/home/components/CategorySection";
import DynamicsSection from "@/pages/home/components/DynamicsSection";
import GuideSection from "@/pages/home/components/GuideSection";
import FaqSection from "@/pages/home/components/FaqSection";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  const [replayCategory, setReplayCategory] = useState("全部");

  useEffect(() => {
    const nodes = Array.from(document.querySelectorAll<HTMLElement>("[data-reveal]"));

    if (typeof IntersectionObserver === "undefined") {
      nodes.forEach((node) => node.classList.add("is-visible"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" },
    );

    const register = (root: ParentNode) => {
      root.querySelectorAll<HTMLElement>("[data-reveal]").forEach((node) => {
        if (node.dataset.revealBound === "1") return;
        node.dataset.revealBound = "1";
        observer.observe(node);
      });
    };

    register(document);

    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches("[data-reveal]") && node.dataset.revealBound !== "1") {
            node.dataset.revealBound = "1";
            observer.observe(node);
          }
          register(node);
        });
      });
    });

    mutationObserver.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      mutationObserver.disconnect();
    };
  }, []);

  const handleSelectCategory = (category: string) => {
    setReplayCategory(category);
    const el = document.getElementById("replay");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <NoticeBar />
        <ReplaySection
          activeCategory={replayCategory}
          onCategoryChange={setReplayCategory}
        />
        <WelfareSection />
        <RankingSection />
        <CategorySection onSelectCategory={handleSelectCategory} />
        <DynamicsSection />
        <GuideSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}